module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: (_vm.tooltip),
      expression: "tooltip",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "flag",
    class: _vm.getCountryClass(_vm.alpha2)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4933d19d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CountryBadge/CountryBadge.vue
// module id = 3708
// module chunks = 1